<template>
	<div>
		<div class="analysisBox" v-if="!matrixSpikeType">
			<div class="resultDisplay">
				<div @click="activeAnalyse(item)" v-for="item in analyseList" :key="item.id" :class="analyseId == item.id ? 'analyseTrue' : 'analyseFalse'">{{ item.name }}</div>
			</div>
			<div class="analysisResult">
				<div class="resultBtn">
					<div>
						<el-button type="primary" @click="openMatrixSpike">添加分析</el-button>
						<el-button type="primary">设置数据标签</el-button>
					</div>
					<div>
						<el-button @click="exportppt">导出为ppt</el-button>
						<el-button>导出word</el-button>
						<el-button>分享</el-button>
					</div>
				</div>
				<div class="resultList">
					<div v-for="(item, index) in analysisReportList" :key="index">
						<barChart :analysisData="item.analysisData" v-if="item.type == 1"></barChart>
						<tableData :analysisData="item.analysisData" v-if="item.type == 2"></tableData>
						<explain :analysisData="item.analysisData" v-if="item.type == 3"></explain>
						<!-- <boxPlot></boxPlot> -->
						<scatterDiagram :analysisData="item.analysisData" v-if="item.type == 4"></scatterDiagram>
					</div>
					<!-- <el-empty description="暂无分析结果"></el-empty> -->
				</div>
			</div>
		</div>
		<matrixSpike v-else @subAnalysis="subAnalysis"></matrixSpike>
	</div>
</template>

<script>
import matrixSpike from '@/page/dataAnalysis/matrixSpike';
import scatterDiagram from '@/page/dataAnalysis/echarts/scatterDiagram.vue';
import barChart from '@/page/dataAnalysis/echarts/barChart.vue';
import boxPlot from '@/page/dataAnalysis/echarts/boxPlot.vue';
import tableData from '@/page/dataAnalysis/echarts/tableData.vue';
import explain from '@/page/dataAnalysis/echarts/explain.vue';
export default {
	components: {
		matrixSpike,
		scatterDiagram,
		barChart,
		// boxPlot,
		tableData,
		explain
	},
	data() {
		return {
			analysisReportList: [
				{
					type: 2,
					analysisData: {
						title: '基础指标',
						dataArrayList: [
							['名称', '样本量', '最小值', '最大值', '平均值', '标准差', '中位数'],
							['信息认可度实体店体验', '58', '6.000', '10.000', '8.414', '0.795', '8.000'],
							['信息认可度官方网站客服热线官微等信息', '23', '6.000', '10.000', '8.391', '1.076', '9.000']
						],
						answerNumber: null
					}
				},
				{
					type: 3,
					analysisData: {
						title: '分析建议',
						dataArrayList: [
							'描述分析用于研究定量数据的整体情况，整体平均得分情况如何等；',
							'第一：整体描述分析项平均得分值情况；',
							'第二：着重对平均值较高，或者明显较低分析项进行说明；',
							'第三：如果标准差值较大，可考虑使用中位数表示整体打分情况；',
							'第四：对分析进行总结。',
							'另外还提供比如方差，分位数，偏度和峰度等指标。'
						],
						answerNumber: null
					}
				},
				{
					type: 3,
					analysisData: {
						title: '智能分析',
						dataArrayList: [
							'描述性分析通过平均值或中位数描述数据的整体情况。从上表可以看出：当前数据中并没有异常值，因而建议可直接针对平均值进行描述分析。总结可知，数据中没有异常值出现，可直接针对平均值进行描述分析。以及如果需要更多详细细节指标请参考下表。'
						],
						answerNumber: null
					}
				},
				{
					type: 1,
					analysisData: {
						title: '平均值对比图',
						dataArrayList: [],
						axisTitle:['信息认可度实体店体验', '信息认可度官方网站客服热线官微等信息'],
						seriesData:[8.41, 8.39],
						answerNumber: null
					}
				},
				{
					type: 2,
					analysisData: {
						title: '深入指标',
						dataArrayList: [
							[
								'名称',
								'平均值±标准差',
								'方差',
								'25分位数',
								'中位数',
								'75分位数',
								'标准误',
								'均值95% CI(LL)',
								'均值95% CI(UL)',
								'IQR',
								'峰度',
								'偏度',
								'变异系数(CV)'
							],
							['信息认可度实体店体验', '8.414±0.795', '0.633', '8.000', '8.000', '9.000', '0.104', '8.209', '8.619', '1.000', '0.764', '-0.032', '9.454%'],
							[
								'信息认可度官方网站客服热线官微等信息',
								'8.391±1.076',
								'1.158',
								'8.000',
								'9.000',
								'9.000',
								'0.224',
								'7.952',
								'8.831',
								'1.000',
								'-0.377',
								'-0.411',
								'12.825%'
							]
						],
						answerNumber: null
					}
				},
				{
					type: 2,
					analysisData: {
						title: '百分位数',
						dataArrayList: [
							['名称', 'P2.5', 'P5', 'P10', 'P25', 'P27', 'P33', 'P50', 'P67', 'P73', 'P75', 'P90', 'P95', 'P97.5'],
							['信息认可度实体店体验', '6.475', '7.000', '8.000', '8.000', '8.000', '8.000', '8.000', '9.000', '9.000', '9.000', '9.100', '10.000', '10.000'],
							[
								'信息认可度官方网站客服热线官微等信息',
								'6.000',
								'6.200',
								'7.000',
								'8.000',
								'8.000',
								'8.000',
								'9.000',
								'9.000',
								'9.000',
								'9.000',
								'10.000',
								'10.000',
								'10.000'
							]
						],
						answerNumber: null
					}
				}
			],
			analyseId: '0',
			analyseList: [
				{
					id: '0',
					name: '描述分析'
				},
				{
					id: '1',
					name: '频数分析'
				}
			],
			matrixSpikeType: false
		};
	},
	created() {},
	methods: {
		subAnalysis(){
			console.log(1111111111)
			this.matrixSpikeType = false
		},
		activeAnalyse(item) {
			if (item.id == 0) {
				this.analysisReportList = [
					{
						type: 2,
						analysisData: {
							title: '基础指标',
							dataArrayList: [
								['名称', '样本量', '最小值', '最大值', '平均值', '标准差', '中位数'],
								['信息认可度实体店体验', '58', '6.000', '10.000', '8.414', '0.795', '8.000'],
								['信息认可度官方网站客服热线官微等信息', '23', '6.000', '10.000', '8.391', '1.076', '9.000']
							],
							answerNumber: null
						}
					},
					{
						type: 3,
						analysisData: {
							title: '分析建议',
							dataArrayList: [
								'描述分析用于研究定量数据的整体情况，整体平均得分情况如何等；',
								'第一：整体描述分析项平均得分值情况；',
								'第二：着重对平均值较高，或者明显较低分析项进行说明；',
								'第三：如果标准差值较大，可考虑使用中位数表示整体打分情况；',
								'第四：对分析进行总结。',
								'另外还提供比如方差，分位数，偏度和峰度等指标。'
							],
							answerNumber: null
						}
					},
					{
						type: 3,
						analysisData: {
							title: '智能分析',
							dataArrayList: [
								'描述性分析通过平均值或中位数描述数据的整体情况。从上表可以看出：当前数据中并没有异常值，因而建议可直接针对平均值进行描述分析。总结可知，数据中没有异常值出现，可直接针对平均值进行描述分析。以及如果需要更多详细细节指标请参考下表。'
							],
							answerNumber: null
						}
					},
					{
						type: 1,
						analysisData: {
							title: '平均值对比图',
							dataArrayList: [],
							axisTitle:['信息认可度实体店体验', '信息认可度官方网站客服热线官微等信息'],
							seriesData:[8.41, 8.39],
							answerNumber: null
						}
					},
					{
						type: 2,
						analysisData: {
							title: '深入指标',
							dataArrayList: [
								[
									'名称',
									'平均值±标准差',
									'方差',
									'25分位数',
									'中位数',
									'75分位数',
									'标准误',
									'均值95% CI(LL)',
									'均值95% CI(UL)',
									'IQR',
									'峰度',
									'偏度',
									'变异系数(CV)'
								],
								['信息认可度实体店体验', '8.414±0.795', '0.633', '8.000', '8.000', '9.000', '0.104', '8.209', '8.619', '1.000', '0.764', '-0.032', '9.454%'],
								[
									'信息认可度官方网站客服热线官微等信息',
									'8.391±1.076',
									'1.158',
									'8.000',
									'9.000',
									'9.000',
									'0.224',
									'7.952',
									'8.831',
									'1.000',
									'-0.377',
									'-0.411',
									'12.825%'
								]
							],
							answerNumber: null
						}
					},
					{
						type: 2,
						analysisData: {
							title: '百分位数',
							dataArrayList: [
								['名称', 'P2.5', 'P5', 'P10', 'P25', 'P27', 'P33', 'P50', 'P67', 'P73', 'P75', 'P90', 'P95', 'P97.5'],
								['信息认可度实体店体验', '6.475', '7.000', '8.000', '8.000', '8.000', '8.000', '8.000', '9.000', '9.000', '9.000', '9.100', '10.000', '10.000'],
								[
									'信息认可度官方网站客服热线官微等信息',
									'6.000',
									'6.200',
									'7.000',
									'8.000',
									'8.000',
									'8.000',
									'9.000',
									'9.000',
									'9.000',
									'9.000',
									'10.000',
									'10.000',
									'10.000'
								]
							],
							answerNumber: null
						}
					}
				];
			} else if (item.id == 1) {
				console.log(item)
				this.analysisReportList = []
				this.analysisReportList = [
					{
						type: 2,
						analysisData: {
							title: '频数分析结果',
							dataArrayList: [
								['名称', '选项', '频数', '百分比(%)', '累积百分比(%)'],
								['电视分辨率(n=7)', '6.0	', '7', '100.00', '100.00'],
								['合计','', '100', '100.0', '100.0']
							],
							answerNumber: null
						}
					},
					{
						type: 3,
						analysisData: {
							title: '分析建议',
							dataArrayList: [
								'频数分析用于研究定类数据的分布情况，选择频数和百分比分别是多少；',
								'第一：首先描述研究数据基本情况；',
								'第二：逐一对每个分析项进行分析，并且着重分析选择比例较多的选项；',
								'第三：对分析进行总结。',
							],
							answerNumber: null
						}
					},
					{
						type: 3,
						analysisData: {
							title: '智能分析',
							dataArrayList: [
								'从上表可知：样本中100.00%会选择“6.0”。'
							],
							answerNumber: null
						}
					},
					{
						type: 2,
						analysisData: {
							title: '电视分辨率',
							dataArrayList: [
								['项', '频数', '频数', '百分比', '累积百分比'],
								['6.0', '7', '7', '100.00%', '100.00%'],
								['合计','7', '100', '100.0%']
							],
							answerNumber: null
						}
					},
					{
						type: 1,
						analysisData: {
							title: '电视分辨率',
							dataArrayList: [],
							axisTitle:['6.00'],
							seriesData:[100],
							answerNumber: null
						}
					},
					
				];
			}
			this.analyseId = item.id;
		},
		openMatrixSpike() {
			this.matrixSpikeType = true;
		},
		exportppt(){
			window.open(this.$config.service.importPpt + '?Authorization=' + 'Bearer ' + window.localStorage.getItem('token'));
		}
	}
};
</script>

<style lang="scss" scoped>
.analysisBox {
	margin-left: 90px;
	padding: 20px;
	display: flex;
	.resultDisplay {
		width: 300px;
		min-height: 780px;
		background-color: rgba(255, 255, 255, 1);
		.analyseTrue {
			color: #0080ff;
			height: 30px;
			line-height: 30px;
			text-align: left;
			cursor: pointer;
			padding-left: 20px;
		}
		.analyseFalse {
			height: 30px;
			line-height: 30px;
			text-align: left;
			cursor: pointer;
			padding-left: 20px;
		}
	}
	.analysisResult {
		flex: 1;
		margin-left: 10px;
		.resultBtn {
			display: flex;
			justify-content: space-between;
		}
		.resultList {
			margin-top: 20px;
			min-height: 780px;
			background-color: rgba(230, 230, 230, 1);
		}
	}
}
</style>
